import { Block } from 'components/Block'
import {
  FutureMessagesAction,
  FutureMessagesContent,
} from 'components/content/lifeStories/futureMessagesTab/FutureMessagesTab'
import { LifeStoriesContextProvider } from 'components/content/lifeStories/LifeStoriesContext'
import { LifeStoriesGallery } from 'components/content/lifeStories/LifeStoriesGallery/LifeStoriesGallery'
import { HeaderDashboard } from 'components/header/headerDashboard/HeaderDashboard'
import { getMemoryGalleryTab, LifeStoriesCustomTab } from 'components/memory/MemoryUtils'
import { PageTitle } from 'components/PageTitle'
import { ProfileContent, ProfileWrapper } from 'components/profile/profileContent/ProfileContent'
import { ProfileSidebar } from 'components/profile/profileSidebar/ProfileSidebar'
import { SideLayout } from 'components/sideLayout/SideLayout'
import { Spacer } from 'components/spacer/Spacer'
import { Stack } from 'components/Stack'
import { Text } from 'components/Typography'
import { WizardHero } from 'components/wizard/wizardHero/WizardHero'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const { t: tCommon } = useTranslation()
  const { t } = useTranslation('life_stories')

  const FutureMessagesTab: LifeStoriesCustomTab = {
    label: tCommon('common.memory_gallery_tabs.future_messages'),
    customContent: <FutureMessagesContent />,
    action: <FutureMessagesAction />,
    key: 'future-messages',
  }
  const tabs = getMemoryGalleryTab(tCommon)
  return (
    <LifeStoriesContextProvider>
      <SideLayout left={<ProfileSidebar />} header={<HeaderDashboard />}>
        <PageTitle title={t('life_stories.inside_page.meta_title')} />

        <Block>
          <ProfileWrapper>
            <ProfileContent hideBack css={{ width: '100%' }}>
              <WizardHero
                caption={t('life_stories.inside_page.caption')}
                title={t('life_stories.inside_page.title')}
                pictureKey={'illustrations/life-stories'}
              >
                <Stack space={'1rem'}>
                  <Text variant={'body'}>{t('life_stories.inside_page.desc')} </Text>
                </Stack>
              </WizardHero>

              <Spacer size={2} />

              <LifeStoriesGallery
                tabs={[tabs.all, tabs.story, tabs.singing, tabs.live]}
                customTabs={[FutureMessagesTab]}
              />
            </ProfileContent>
          </ProfileWrapper>
        </Block>
      </SideLayout>
    </LifeStoriesContextProvider>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, ['life_stories', 'memory'], true)) } }
}
